export function header() {
  const el = document.querySelector('.header');
  if (!el) return;

  const THRESHOLD = 10;        // anti-jitter
  const SCROLLED_BG = 50;      // vanaf wanneer .scrolled op header
  let lastY = Math.max(0, window.scrollY || 0);
  let direction = 'up';
  let ticking = false;
  let endTimer;

  function apply(show) {
	if (show) {
	  el.classList.remove('hidden');
	  el.classList.add('visible');
	} else {
	  el.classList.remove('visible');
	  el.classList.add('hidden');
	}
  }

  function update() {
	const y = Math.max(0, window.scrollY || window.pageYOffset || 0);

	// Achtergrond toggle
	if (y > SCROLLED_BG) el.classList.add('scrolled');
	else el.classList.remove('scrolled');

	// Bovenaan? Altijd tonen om Safari-witvlak te voorkomen
	if (y <= 1) {
	  apply(true);
	  direction = 'up';
	} else if (y > lastY + THRESHOLD) {
	  if (direction !== 'down') {
		apply(false); // verberg bij omlaag
		direction = 'down';
	  }
	} else if (y < lastY - THRESHOLD) {
	  if (direction !== 'up') {
		apply(true); // toon bij omhoog
		direction = 'up';
	  }
	}

	lastY = y;
	ticking = false;

	// "scrollend" polyfill: na momentum scroll, als we (bijna) boven zijn, header tonen
	clearTimeout(endTimer);
	endTimer = setTimeout(() => {
	  const nowY = Math.max(0, window.scrollY || 0);
	  if (nowY <= SCROLLED_BG) apply(true);
	}, 120);
  }

  // Initial state
  apply(true);

  window.addEventListener('scroll', () => {
	if (!ticking) {
	  requestAnimationFrame(update);
	  ticking = true;
	}
  }, { passive: true });

  // Resync na tab-wissel/rotate (iOS Safari kan scrollY “vergeten”)
  window.addEventListener('visibilitychange', () => {
	if (!document.hidden) update();
  });
  window.addEventListener('orientationchange', () => {
	lastY = Math.max(0, window.scrollY || 0);
	requestAnimationFrame(update);
  });
}